import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-switchingFloor",
  "use": "icon-switchingFloor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-switchingFloor\"><path d=\"M904.4 904.4V568.1L680.2 371.8V63.5H119.6v840.9H63.5v56.1h897v-56.1h-56.1zm-280.3 0H175.6V119.6h448.5v784.8zm224.3 0H680.2V461.5l168.2 140.2v302.7zM512 343.8H287.8v56.1H512v-56.1zm0 168.2H287.8v56.1H512V512zm0 168.2H287.8v56.1H512v-56.1zm280.3 0h-56.1v56.1h56.1v-56.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol